import React from 'react';
import Image from 'next/image';
import logo from '../../public/img/logos/logo-carreras-dark.png';
import SidebarApplicationItem from './SidebarApplicationItem';
import { steps, TStep } from '../steps';

interface SidebarApplicationProps {
  step: TStep;
}

export default function SidebarApplication({ step }: SidebarApplicationProps) {
  return (
    <div className="w-full h-screen bg-dark-blue max-h-screen ">
      <Image src={logo} height={82.36} width={250} alt="Carreras logo" />
      <div className="mt-32 px-10">
        <h2 className="font-bold text-2xl text-white">{step?.name ?? ''}</h2>
        <p className="text-[18px] text-white">{step?.description ?? ''}</p>
      </div>
      <div className="mt-8 px-10 space-y-4">
        {steps.map((s) =>
          s.notShow ? null : (
            <SidebarApplicationItem
              key={s.id}
              step={s}
              currentStepId={step.id}
            />
          )
        )}
      </div>
    </div>
  );
}
